
<div class="flex flex-col max-w-7xl mx-auto sm:my-12 sm:rounded-2xl bg-default sm:shadow-2xl">

<div class="flex flex-col w-full">
    <!-- header -->
    <div
        class="bg-card dark:bg-default bg-gradient-to-tr dark:from-primary-950 from-primary-100 from-0% via-transparent via-80% sm:rounded-t-2xl">
        <div class="mx-auto px-6 sm:px-8">
            <div class="flex flex-col lg:flex-row items-center my-8 sm:my-12 space-x-2 sm:space-x-5 gap-6">
                <div class="flex flex-row justify-between items-center w-full">
                    <div class="flex flex-row items-center">
                        <div class="mx-auto w-24 sm:w-40">
                            <img src="assets/images/logo/logo_smm_black.svg" alt="Smiles Manager logo">
                        </div>
                        <div class="flex flex-col sm:ml-4">
                            <ng-container *transloco="let t">
                                <div
                                    class="text-3xl md:text-8xl font-semibold tracking-tight leading-7 md:leading-snug truncate">{{ t('Oferta Smiles Manager') }}
                                </div>
                            </ng-container>
                            <div class="ml-1.5 leading-6 truncate text-secondary md:text-xl">
                                {{'Platforma dedicata nevoilor tale' | transloco}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="flex flex-col w-full sm:w-fit px-1 py-1 sm:rounded-full sm:bg-card sm:shadow sm:ml-6 sm:-mt-6">
        <mat-button-toggle-group  [(value)]="tabSelected" class="flex flex-col sm:flex-row gap-2 min-w-fit h-fit">
            <mat-button-toggle value="home" [routerLink]="'../'">
                <mat-icon class="icon-size-5" [svgIcon]="'mat_solid:home'"></mat-icon>
            </mat-button-toggle>
            <mat-button-toggle value="modules" >
                <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:puzzle-piece'"></mat-icon>
                Module
            </mat-button-toggle>
            <mat-button-toggle value="resources">
                <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:cpu-chip'"></mat-icon>
                Resurse
            </mat-button-toggle>
            <mat-button-toggle value="calculator">
                <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:calculator'"></mat-icon>
                Calculator preț
            </mat-button-toggle>
        </mat-button-toggle-group>
    </div>

    <ng-container *ngIf="tabSelected=='calculator'">
        <div class="flex flex-col md:flex-row justify-between items-center w-full p-4 gap-4">
            <fuse-card class="flex flex-col w-full md:h-full p-4 font-light italic font-stretch-extra-expanded text-justify text-secondary">
                <p>Smiles Manager este o platformă flexibilă, construită astfel încât fiecare utilizator să își poată personaliza exact modulele și resursele de care are nevoie, fără costuri inutile.</p>
                <div class="text text-lg font-semibold mt-4">1. Cate unit-uri dentare sunt în clinica?</div>
                <input class="min-h-10 border-collapse border-2 border-gray-200 darK:border-gray-700 rounded-xl px-4 w-20"
                       type="number" [(ngModel)]="input.units" (change)="updateOffer()"/>

                <div class="text text-lg font-semibold mt-4">2. Ce funcționalități doriți să folosiți?</div>
                <div class="text text-sm text-hint">Pentru detalii consultați secțiunea 'Module' de mai jos</div>
                <div class="flex flex-col gap-4 mt-4">
                    <mat-checkbox
                        class="flex items-center p-4 border-2 rounded-lg bg-primary/5 shadow-lg hover:shadow-xl transition-all duration-200"
                        [(ngModel)]="input.full" [color]="'primary'" (change)="updateFull()"
                        [ngClass]="{'border-primary': input.full}">
                        <div class="flex flex-col">
                            <div class="flex items-center gap-2">
                                <div [ngClass]="{'font-bold': input.full}" class="text-lg">FULL</div>
                                <mat-icon class="icon-size-6 text-primary"
                                          [svgIcon]="'heroicons_outline:star'"></mat-icon>
                            </div>
                            <div class="text-secondary text-sm leading-tight">Include toate funcționalitățiile si
                                modulele
                            </div>
                        </div>
                    </mat-checkbox>
                    <mat-divider></mat-divider>
                    <mat-checkbox class="flex items-center" [(ngModel)]="input.modCalendar" [color]="'primary'" (change)="updateOffer()">
                        <div [ngClass]="{'font-bold': input.modCalendar}">Calendar si programări</div>
                        <div class="text-secondary text-sm leading-tight">{{getFMap().get('3')?.summary}}</div>
                    </mat-checkbox>
                    <mat-divider></mat-divider>
                    <mat-checkbox class="flex items-center" [(ngModel)]="input.modDocClinic" [color]="'primary'" (change)="updateOffer()">
                        <div [ngClass]="{'font-bold': input.modDocClinic}">Documentare clinica interactiva si plan de tratament</div>
                        <div class="text-secondary text-sm leading-tight">{{getFMap().get('4')?.summary}}</div>
                    </mat-checkbox>
                    <mat-divider></mat-divider>
                    <mat-checkbox class="flex items-center" [(ngModel)]="input.modDocs" [color]="'primary'" (change)="updateOffer()">
                        <div [ngClass]="{'font-bold': input.modDocs}">Documente digitale si chestionare</div>
                        <div class="text-secondary text-sm leading-tight">{{getFMap().get('5')?.summary}}</div>
                    </mat-checkbox>
                    <mat-divider></mat-divider>
                    <mat-checkbox class="flex items-center" [(ngModel)]="input.modMultimedia" [color]="'primary'" (change)="updateOffer()">
                        <div [ngClass]="{'font-bold': input.modMultimedia}">Multimedia</div>
                        <div class="text-secondary text-sm leading-tight">{{getFMap().get('8')?.summary}}</div>
                    </mat-checkbox>
                    <mat-divider></mat-divider>
                    <mat-checkbox class="flex items-center" [(ngModel)]="input.modRapoarte" [color]="'primary'" (change)="updateOffer()">
                        <div [ngClass]="{'font-bold': input.modRapoarte}">Radiografie afacere</div>
                        <div class="text-secondary text-sm leading-tight">{{getFMap().get('6')?.summary}}</div>
                    </mat-checkbox>
                    <mat-divider></mat-divider>
                    <mat-checkbox class="flex items-center" [(ngModel)]="input.modSterilizare" [color]="'primary'" (change)="updateOffer()">
                        <div [ngClass]="{'font-bold': input.modSterilizare}">Trasabilitatea sterilizarii</div>
                        <div class="text-secondary text-sm leading-tight">{{getFMap().get('7')?.summary}}</div>
                    </mat-checkbox>
                    <mat-divider></mat-divider>
                    <mat-checkbox class="flex items-center" [(ngModel)]="input.modRecall" [color]="'primary'" (change)="updateOffer()">
                        <div [ngClass]="{'font-bold': input.modRecall}">Recall</div>
                        <div class="text-secondary text-sm leading-tight">{{getFMap().get('A')?.summary}}</div>
                    </mat-checkbox>
                    <mat-divider></mat-divider>
                    <mat-checkbox class="flex items-center" [(ngModel)]="input.modFinancial" [color]="'primary'" (change)="updateOffer()">
                        <div [ngClass]="{'font-bold': input.modFinancial}">Financiar</div>
                        <div class="text-secondary text-sm leading-tight">{{getFMap().get('B')?.summary}}</div>
                    </mat-checkbox>
                </div>

                <div class="text text-lg font-semibold mt-4">3. Doriti comunicare automata?</div>
                <div class="text text-sm text-hint">(confirmari, remindere, recall..)</div>
                <div class="flex flex-row gap-2 items-center">
                    <mat-checkbox class="flex items-center" [(ngModel)]="input.sms" [color]="'primary'" (change)="updateOffer()">SMS</mat-checkbox>
                    <mat-checkbox class="flex items-center" [(ngModel)]="input.email" [color]="'primary'" (change)="updateOffer()">E-Mail</mat-checkbox>
                </div>

                <ng-container *ngIf="input.sms && input.email">
                    <div class="text text-lg font-semibold mt-4">4. Cum prefera pacienții dvs. sa comunice?</div>
                    <div class="text text-sm text-hint">Estimativ ...</div>
                    <div class="flex flex-row gap-2 items-center">
                        <div class="text-lg text-hint">SMS ({{input.percSMS*10}}%)</div>
                        <mat-slider min="0" max="10" step="1">
                            <input matSliderThumb value="5"  (input)="input.percSMS=10-$event.target.value; input.percEmail = 10-input.percSMS; updateOffer()">
                        </mat-slider>
                        <div class="text-lg text-hint">E-mail ({{input.percEmail*10}}%)</div>
                    </div>
                </ng-container>

                <ng-container *ngIf="input.sms || input.email">
                    <div class="text text-lg font-semibold mt-4">{{(input.sms && input.email)?'5':'4'}}. Cum configurați comunicarea automata?</div>
                    <div class="text text-sm text-hint">(Numărul de SMS-uri impactează mult costul lunar)</div>
                    <div class="flex flex-row gap-2 items-center">
                        <mat-checkbox class="flex items-center" [(ngModel)]="input.confirmare" [color]="'primary'" (change)="updateOffer()">Mesaj confirmare</mat-checkbox>
                        <mat-checkbox class="flex items-center" [(ngModel)]="input.reminder1" [color]="'primary'" (change)="updateOffer()">Reamintire înainte cu 1 zi</mat-checkbox>
                        <mat-checkbox class="flex items-center" [(ngModel)]="input.reminder2" [color]="'primary'" (change)="updateOffer()">Reamintire înainte cu 2 ore</mat-checkbox>
                    </div>
                </ng-container>

                <ng-container *ngIf="input.sms || input.email">
                    <div class="text text-lg font-semibold mt-4">{{(input.sms && input.email)?'6':'5'}}. Cate programări, pe zi, in medie, aveți în clinica?</div>
                    <div class="text text-sm text-hint">Estimativ ...</div>
                    <input class="min-h-10 border-collapse border-2 border-gray-200 darK:border-gray-700 rounded-xl px-4 w-20"
                           type="number" [(ngModel)]="input.programari" (change)="updateOffer()"/>
                </ng-container>
            </fuse-card>

            <fuse-card class="flex flex-col w-full md:h-full p-4 font-light italic font-stretch-extra-expanded text-justify">
                <div class="text-3xl font-semibold w-full text-center">Rezultat Simulare Preț</div>

                <div class="grid grid-cols-12 gap-x-1 mx-4 text-secondary">
                    <!-- Columns -->
                    <div class="col-span-8 font-medium text-md text-secondary">Articol</div>
                    <div class="col-span-4 font-medium text-md text-right text-secondary">Pret</div>

                    <!-- Divider -->
                    <div class="col-span-12 my-2 border-b"></div>
                    <div class="col-span-8 text-lg font-medium">Unituri dentare ({{input.units}} -> max {{input.units * 3}} medici) </div>
                    <div class="col-span-4 self-center text-right">{{ output.costUnit | number: '1.2-2'}} <sup>RON</sup></div>

                    <ng-container *ngIf="input.sms || input.email">
                        <ng-container *ngIf="input.sms">
                            <!-- Divider -->
                            <div class="col-span-12 my-2 border-b"></div>
                            <div class="col-span-8 text-lg font-medium">SMS ({{output.smsNr}})</div>
                            <div class="col-span-4 self-center text-right">{{ output.smsCost | number: '1.2-2'}} <sup>RON</sup></div>
                        </ng-container>
                        <ng-container *ngIf="input.email">
                            <!-- Divider -->
                            <div class="col-span-12 my-2 border-b"></div>
                            <div class="col-span-8 text-lg font-medium">Emails ({{output.emailNr}})</div>
                            <div class="col-span-4 self-center text-right">{{ output.emailCost | number: '1.2-2'}} <sup>RON</sup></div>
                        </ng-container>
                    </ng-container>
                    <ng-container *ngIf="input.modCalendar">
                        <!-- Divider -->
                        <div class="col-span-12 my-2 border-b"></div>
                        <div class="col-span-8 text-lg font-medium">Calendar si programări </div>
                        <div class="col-span-4 self-center text-right">{{ output.costModCalendar | number: '1.2-2'}} <sup>RON</sup></div>
                    </ng-container>
                    <ng-container *ngIf="input.modDocClinic">
                        <!-- Divider -->
                        <div class="col-span-12 my-2 border-b"></div>
                        <div class="col-span-8 text-lg font-medium">Documentare clinica si plan tratament </div>
                        <div class="col-span-4 self-center text-right">{{ output.costModDocClinic | number: '1.2-2'}} <sup>RON</sup></div>
                    </ng-container>
                    <ng-container *ngIf="input.modSterilizare">
                        <!-- Divider -->
                        <div class="col-span-12 my-2 border-b"></div>
                        <div class="col-span-8 text-lg font-medium">Trasabilitatea sterilizării </div>
                        <div class="col-span-4 self-center text-right">{{ output.costModSterilizare | number: '1.2-2'}} <sup>RON</sup></div>
                    </ng-container>
                    <ng-container *ngIf="input.modRapoarte">
                        <!-- Divider -->
                        <div class="col-span-12 my-2 border-b"></div>
                        <div class="col-span-8 text-lg font-medium">Radiografia afacerii (grafice si metrici) </div>
                        <div class="col-span-4 self-center text-right">{{ output.costModRapoarte | number: '1.2-2'}} <sup>RON</sup></div>
                    </ng-container>
                    <ng-container *ngIf="input.modDocs">
                        <!-- Divider -->
                        <div class="col-span-12 my-2 border-b"></div>
                        <div class="col-span-8 text-lg font-medium">Documente si chestionare digitale </div>
                        <div class="col-span-4 self-center text-right">{{ output.costModDocs | number: '1.2-2'}} <sup>RON</sup></div>
                    </ng-container>
                    <ng-container *ngIf="input.modMultimedia">
                        <!-- Divider -->
                        <div class="col-span-12 my-2 border-b"></div>
                        <div class="col-span-8 text-lg font-medium">Multimedia (5Gb)</div>
                        <div class="col-span-4 self-center text-right">{{ output.costModMultimedia | number: '1.2-2'}} <sup>RON</sup></div>
                    </ng-container>
                    <ng-container *ngIf="input.modRecall">
                        <!-- Divider -->
                        <div class="col-span-12 my-2 border-b"></div>
                        <div class="col-span-8 text-lg font-medium">Recall</div>
                        <div class="col-span-4 self-center text-right">{{ output.costModRecall | number: '1.2-2'}} <sup>RON</sup></div>
                    </ng-container>
                    <ng-container *ngIf="input.modFinancial">
                        <!-- Divider -->
                        <div class="col-span-12 my-2 border-b"></div>
                        <div class="col-span-8 text-lg font-medium">Financiar</div>
                        <div class="col-span-4 self-center text-right">{{ output.costModFinancial | number: '1.2-2'}} <sup>RON</sup></div>
                    </ng-container>
                </div>

                <!-- Divider -->
                <div class="col-span-12 my-2 border-b"></div>

                <div class="grid grid-cols-8 gap-1">

                    <div class="col-span-5 text-md text-hint font-extrabold px-4">Cost fix</div>
                    <div class="col-span-3 text-md text-hint font-extrabold px-4 text-right">({{output.costFix | number: '1.2-2'}} <sup>RON</sup>) </div>

                    <div class="col-span-5 text-md text-hint font-extrabold px-4">Cost variabil, estimativ (resurse)</div>
                    <div class="col-span-3 text-md text-hint font-extrabold px-4 text-right">({{output.costRes | number: '1.2-2'}} <sup>RON</sup>) </div>
                </div>

                <div class="flex flex-col w-full font-light italic font-stretch-extra-expanded text-justify text-secondary px-4 mb-6 mt-4">
                    <p>* costurile reale lunare variază datorita politicii 'pay as you go' unde vei plăti exact cat consumi. Aceasta estimarea considera scenariul cel mai negativ in care consumul de resurse este maxim, așadar rareori costul real va depăși aceasta estimare.</p>
                </div>

                <ul class="space-y-4 px-4">
                    <li class="flex items-center space-x-3 text-lg text-secondary">
                        <mat-icon  svgIcon="mat_outline:devices"></mat-icon>
                        <span>0 (ZERO) echipamente dedicate pt SMS</span>
                    </li>
                    <li class="flex items-center space-x-3 text-lg text-secondary">
                        <mat-icon  svgIcon="mat_outline:dns"></mat-icon>
                        <span>0 (ZERO) HW scump, si întreținerea aferenta (server, backup)</span>
                    </li>
                    <li class="flex items-center space-x-3 text-lg text-secondary">
                        <mat-icon  svgIcon="heroicons_outline:globe-alt"></mat-icon>
                        <span>Accesibil de oriunde, oricând, de pe orice dispozitiv: (laptop, PC, tableta,telefon, Windows, Android, MAC, Linux.. )</span>
                    </li>
                    <li class="flex items-center space-x-3 text-lg font-bold">
                        <mat-icon  svgIcon="heroicons_outline:sparkles"></mat-icon>
                        <span>DOAR PRODUCTIVITATE PURA</span>
                    </li>
                </ul>

                <div class="h-full">
                    <!-- Filler-->
                </div>

<!--                <div class="rounded-full flex justify-center items-center bg-[#f5f5f5] max-w-64 p-6 shadow-lg mx-auto">-->
<!--                    <img class="rounded-full" src="assets/images/ui/smm/dental_eficiency.png">-->
<!--                </div>-->

<!--                <div class="flex rounded-2xl justify-center items-center bg-[#f5f5f5] w-full p-4 mx-auto opacity-70 mt-4">-->
<!--                    <img src="assets/images/ui/smm/dental_eficiency.png" class="w-128">-->
<!--                </div>-->

                <div class="my-4 grid grid-cols-8 gap-1 w-full p-4 border-2 border-dashed border-gray-200 rounded-xl dark:border-gray-700">
                    <div class="flex flex-row items-center col-span-5">
                        <mat-icon
                            matPrefix
                            class="icon-size-6"
                            [svgIcon]="'heroicons_solid:tag'"></mat-icon>
                        <div class="text-3xl font-extrabold px-2">Total</div>
                    </div>
                    <div class="col-span-3 text-3xl font-extrabold px-4 text-right">{{output.total | number: '1.2-2'}} <sup>RON/luna</sup></div>
                </div>

                <button mat-flat-button color="primary" [routerLink]="['/sign-up']">
                    <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:rocket-launch'"></mat-icon>
                    &nbsp;&nbsp;Vreau cont
                </button>
            </fuse-card>


        </div>
    </ng-container>


    <div *ngIf="tabSelected=='resources'" class="grid grid-cols-2 md:flex md:flex-row p-4 gap-4 md:gap-2">
        <ng-container *ngFor="let resource of appResources">
            <fuse-card class="flex flex-col md:max-w-60 w-full" [ngClass]="{'opacity-25':!resource.isAvailable}">
                <div class="relative cursor-pointer" (click)="getMoreInfo(resource)">
                    <img
                        class="object-cover"
                        [src]="resource.cover"
                        alt="Resource cover image">
                </div>


                <div class="mx-3 mb-0 mt-2">
                    <div class="flex flex-col">
                        <div class="text-sm md:text-lg leading-tight">{{resource.name}}</div>
                        <div class="text-sm font-light">{{resource.resRemainLabel}}</div>
                    </div>
                    <hr class="border-b my-2">
                    <div class="flex items-center text-xl mb-4">
                        <span class="text-secondary whitespace-nowrap mr-3">Cost:</span>
                        <span class="mr-2 font-extrabold text-secondary">{{resource.pricePerResource}} <sup>RON</sup></span>
                    </div>
                    <!--                        <div class="mt-6 -mx-8">-->
                    <!--                            <button-->
                    <!--                                [disabled]="resource.isAvailable ? false : 'disabled'"-->
                    <!--                                class="w-full rounded-none"-->
                    <!--                                mat-flat-button-->
                    <!--                                [routerLink]="['/sign-in']">-->
                    <!--                                <mat-icon *ngIf="resource.actionIcon" class="icon-size-5" [svgIcon]="resource.actionIcon"></mat-icon>-->
                    <!--                                <div *ngIf="resource.actionText" class="ml-2">{{resource.actionText}}</div>-->
                    <!--                            </button>-->
                    <!--                        </div>-->
                </div>
            </fuse-card>
        </ng-container>

    </div>


    <div *ngIf="tabSelected=='modules'" class="grid grid-cols-1 gap-8 p-4 content-start">
        <ng-container *ngFor="let module of featModules">
            <!-- MODULE -->
            <div class="flex justify-center">
                <fuse-card class="flex flex-col lg:flex-row w-full bg-gradient-to-l from-0% via-transparent via-80%">

                    <!--    State indicator on large screen-->
                    <div class="hidden lg:flex w-4 min-w-4 max-w-4 min-h-full rounded-l-2xl -mt-2"></div>

                    <!--    State indicator on small screen -->
                    <div class="flex lg:hidden h-4 min-h-4 max-h-4 min-w-full rounded-t-2xl "
                         [ngClass]="{
                            'dark:bg-green-950':module.purchased,
                            'bg-green-200':module.purchased,
                            'dark:bg-red-950':!module.purchased && module.price > 0 && module.active,
                            'bg-red-200':!module.purchased && module.price > 0 && module.active
                    }"></div>


                    <div class="flex-1 p-6 sm:p-8 lg:p-10 w-full">
                        <div class="text-xl sm:text-3xl font-bold flex items-center gap-2">
                            <mat-icon
                                class="icon-size-8"
                                [svgIcon]="module.icon"></mat-icon>
                            <div class="min-w-fit">{{module.name}}</div>
                            <div class="hidden w-full sm:flex justify-end text-sm cursor-pointer text-primary hover:text-primary-400 font-semibold">
                                <a [href]="module.link" target="_blank">Afla mai multe</a>
                            </div>
                        </div>
                        <div class="hidden md:block mt-2 leading-relaxed text-secondary" [innerHTML]="module.description">
                        </div>
                        <div class="hidden md:flex items-center mt-10">
                            <div class="font-medium text-secondary">FUNCTIONALITATI INCLUSE</div>
                            <div class="flex-auto ml-2 border-b-2"></div>
                        </div>
                        <!-- Features -->
                        <div class="grid grid-cols-1 lg:grid-cols-2 gap-y-4 mt-6">
                            <ng-container *ngFor="let feat of module.functionalities">
                                <div class="flex items-center">
                                    <mat-icon
                                        class="icon-size-5 text-primary"
                                        [svgIcon]="feat.icon"></mat-icon>
                                    <div class="ml-2">{{feat.name}}</div>
                                </div>
                            </ng-container>
                        </div>
                        <div class="mt-2 w-full flex sm:hidden justify-end cursor-pointer text-primary hover:text-primary-400 font-semibold">
                            <a [href]="module.link" target="_blank">Afla mai multe</a>
                        </div>
                    </div>
                    <!-- Price -->
                    <div class="flex-2 flex flex-col items-center p-8 lg:px-10 lg:py-12 lg:min-w-80 bg-card border-collapse lg:border-l-2">
                        <div class="flex items-center whitespace-nowrap">
                            <div *ngIf="module.price > 0 && module.active" class="text-8xl font-extrabold tracking-tight">{{module.price}}.00</div>
                            <div *ngIf="module.price > 0 && module.active" class="ml-2 text-2xl font-semibold text-secondary">RON</div>
                            <div *ngIf="module.price == 0 && module.active" class="text-6xl font-extrabold tracking-tight text-green-600">GRATUIT</div>
                        </div>

                        <button class="w-full mt-8 lg:mt-auto"
                                mat-flat-button
                                [routerLink]="['/sign-up']"
                                [color]="(module.purchased && module.partOfSubscription) ?'warn':'primary'">
                            {{ (module.purchased && module.partOfSubscription) ? 'Exclude din abonament':'Activeaza cont'}}
                        </button>
                    </div>
                </fuse-card>
            </div>

        </ng-container>



    </div>

</div>

</div>
